import React from 'react';
import type { Showcase, ShowcaseProperty, ShowcaseResource } from '../../types';

interface AiAssistantSectionProps {
  showcase: Showcase;
  property: ShowcaseProperty;
  resources: ShowcaseResource[];
  brandColour: string;
}

export default function AiAssistantSection({ showcase, property, resources, brandColour }: AiAssistantSectionProps) {
  return null;
}
